<template>
  <validation-observer ref="simpleRules">
    <service-files-item-form />
    <save-button
      :save-action="submitForm"
      :is-disabled="uploading"
    />
  </validation-observer>
</template>

<script>

import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import ServiceFilesItemForm from '@/views/Services/Files/ItemForm.vue'

export default {
  name: 'Edit',
  components: {
    ServiceFilesItemForm,
    ValidationObserver,
    SaveButton,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    uploading() {
      return this.$store.getters['serviceFiles/uploading']
    },
    dataItem() {
      return this.$store.getters['serviceFiles/dataItem']
    },
    saveData() {
      return this.$store.getters['serviceFiles/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.$router.push(`/app/services/edit/${this.$route.params.id}`)
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataItem()
    },
  },
  created() {
    this.getDataItem()
    localize('tr')
  },
  methods: {
    getDataItem() {
      this.$store.dispatch('serviceFiles/getDataItem', this.$route.params.id_service_files)
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          if (this.dataItem.prev_version != null) {
            this.dataItem.versionOptions.prev_version_id = this.dataItem.prev_version
          }
          this.$store.dispatch('serviceFiles/saveData', this.dataItem)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
